<template>
  <div>
    <carousel :perPage="1">
      <slide v-for="episode in episodes" :key="episode.id">
        <h1 class="">{{episode.title}}</h1>
        <ul class="padding">
          <li v-for="chapter in episode.chapters" :key="chapter.id">
            {{chapterTitle(chapter.id)}}
            <ul>
              <li v-for="(story, key) in chapter.titles" :key="key">
                <router-link :to="'/story/' + episode.id + '/' + chapter.id + '/' + key">{{story}}</router-link>
              </li>
            </ul>
          </li>
        </ul>
      </slide>
    </carousel>
  </div>
</template>

<script>
import config from '@/config.js'
export default {

  name: 'Menu',

  data () {
    return {
      episodes: config.episodes
    }
  },
  methods: {
    chapterTitle (id) {
      var num
      if (id === 1) {
        num = 'One'
      } else if (id === 2) {
        num = 'Two'
      } else if (id === 3) {
        num = 'Three'
      } else if (id === 4) {
        num = 'Four'
      } else if (id === 5) {
        num = 'Five'
      }
      return 'Chapter ' + num
    }
  }
}
</script>

<style lang="css" scoped>
</style>
